import { h, Component } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import Button from '../../control-components/ui-components/Button'
import axios from 'axios'

interface Props {
  isGuest: boolean
}

interface ButtonProps {
  isGuest: boolean
}

interface ButtonState {
  isSubscribed: boolean,
  isLoading: boolean
}

class SubscribeButton extends Component<ButtonProps, ButtonState> {
  constructor() {
    super()
    this.state = {
      isSubscribed: false,
      isLoading: false
    }
    this.toggleSubscription = this.toggleSubscription.bind(this)
  }
  async componentDidMount () {
    const result = await axios.get('/product-updates/subscription')
    const isSubscribed = result.data
    this.setState({ isSubscribed })
  }

  async toggleSubscription () {
    this.setState({ isLoading: true })
    const isSubscribed = this.state.isSubscribed
    const url = isSubscribed
      ? '/product-updates/unsubscribe'
      : '/product-updates/subscribe'
    try {
      await axios.post(url)
      this.setState({ isSubscribed: !isSubscribed })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render (props: ButtonProps, state: ButtonState) {
    if (props.isGuest) {
      return <Button toggle disabled>Subscribe</Button>
    }

    return <Button disabled={state.isLoading} toggle toggleActive={state.isSubscribed} onClick={this.toggleSubscription}>
      {state.isSubscribed ? <Phrase p='subscribed.to.updates' /> : <Phrase p='subscribe.to.updates' />}
    </Button>
  }
}

const StatisticsBar = ({ isGuest }: Props) => {
  return (
    <section className='full-width Template-brand-stats custom-stats-bar'>
      <div className='stats-bar p-v qa-stats-bar'>
        <div className='sitewidth'>
          <div className='col'>
            <ul className='list list--stats-bar qa-stats-bar'>
              {/*<li className='list__item'>*/}
                {/*<strong>122</strong>*/}
                {/*<Phrase p='product.updates.overview.title' />*/}
              {/*</li>*/}
            </ul>

            <SubscribeButton isGuest={isGuest}>
              <Phrase p='subscribe.to.updates' />
            </SubscribeButton>
          </div>
        </div>
      </div>
    </section>
  )
}
export default StatisticsBar
